import { render } from "./ContactCoach.vue?vue&type=template&id=46772ae6&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=46772ae6&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46772ae6"]])

export default __exports__